import { connect } from 'react-redux';

import SearchResults from './SearchResults';
import {
    trackDoctorCardClick,
    trackScrolledToSearchResult,
    trackTimesgridDataLoaded,
} from '../../../actions';

import {
    getInsuranceCarrierId,
    getInsurancePlanId,
    getSearchParameters,
} from '../../../state';

import {
    getAvailabilityTimeFilter,
    getAvailabilityTimeFilterForFacetedSearch,
} from '../../../utils/get-availability-time-filter';

import { mockable } from '../../../../config/mockable';

const mapStateToProps = (state, ownProps) => {
    const {
        filters,
        showTimesAfter5,
        showTimesBefore10,
    } = getSearchParameters(state);

    const { shouldRenderFacetedSearchBar, facets } = ownProps;

    const availabilityTimeFilter = shouldRenderFacetedSearchBar
        ? getAvailabilityTimeFilterForFacetedSearch(filters, facets)
        : getAvailabilityTimeFilter(showTimesBefore10, showTimesAfter5);

    return {
        availabilityTimeFilter,
        insuranceCarrierId: getInsuranceCarrierId(state),
        insurancePlanId: getInsurancePlanId(state),
    };
};

const mapDispatchToProps = {
    trackDoctorCardClick,
    trackScrolledToSearchResult,
    trackTimesgridDataLoaded,
};

const SearchResultsConnected = connect(mapStateToProps, mapDispatchToProps)(SearchResults);

const searchResultsResolver = () => SearchResultsConnected;

const SearchResultsMockable = mockable(searchResultsResolver);

export {
    searchResultsResolver,
    SearchResultsMockable as default,
};
